module.exports = __webpack_public_path__ + "static/media/bg.c03accf0.png";